import enResume from './en';
import ruResume from './ru';

export default {
  en: {
    ...enResume,
  },
  ru: {
    ...ruResume,
  },
};
